import React, { useEffect, useState } from 'react'
import { withStyles } from '@material-ui/core'
import styles from './styles'
import { CoverText } from './components'
import CoverHeader from './components/landing-page-header'
import { useDispatch, useSelector } from 'react-redux'
import {
  getCollection,
  getCollectionCourseList,
  getCollectionLandingPageAction,
} from 'src/reducers/collection/action'
import { useParams } from 'react-router-dom'
import { getCourseLandingPageAction } from 'src/reducers/course/action'

const LandingPageEditor = props => {
  const { classes } = props
  const course = useSelector(state => state.course.course)
  const collection = useSelector(state => state.collection.collection)
  const collectionCourses = useSelector(state => state.collection.courses)
  const collectionLandingPage = useSelector(
    state => state.collection.landingPageSettings,
  )
  const courseLandingPage = useSelector(
    state => state.course.landingPageSettings,
  )

  const { id } = useParams()
  const pageUrl = window.location.pathname.split('/')[1]
  const [isLoading, setIsLoading] = useState(true)
  const dispatch = useDispatch()

  const [loadingStates, setLoadingStates] = useState({
    collection: pageUrl === 'collection',
    collectionCourses: pageUrl === 'collection',
    collectionLandingPage: pageUrl === 'collection',
    courseLandingPage: pageUrl === 'mini-course',
  })

  useEffect(() => {
    setIsLoading(true)

    if (pageUrl === 'collection') {
      dispatch(getCollectionCourseList(id))
      dispatch(getCollection(id))
      dispatch(getCollectionLandingPageAction(id))
    } else if (pageUrl === 'mini-course') {
      dispatch(getCourseLandingPageAction(id))
    }
  }, [id, dispatch, pageUrl])

  useEffect(() => {
    if (pageUrl === 'collection') {
      if (collection) {
        setLoadingStates(prev => ({ ...prev, collection: false }))
      }

      if (collectionCourses) {
        setLoadingStates(prev => ({ ...prev, collectionCourses: false }))
      }

      if (collectionLandingPage) {
        setLoadingStates(prev => ({ ...prev, collectionLandingPage: false }))
      }
    }
  }, [collection, collectionCourses, collectionLandingPage, pageUrl])

  useEffect(() => {
    if (pageUrl === 'mini-course' && courseLandingPage) {
      setLoadingStates(prev => ({ ...prev, courseLandingPage: false }))
    }
  }, [courseLandingPage, pageUrl])

  useEffect(() => {
    const stillLoading = Object.values(loadingStates).some(
      state => state === true,
    )
    setIsLoading(stillLoading)
  }, [loadingStates])
  if (isLoading) {
    return ''
  }

  return (
    <div className={classes.root} id="page-view-container">
      <CoverHeader course={course} />
      <div className={classes.container}>
        <CoverText />
      </div>
    </div>
  )
}

export default withStyles(styles)(LandingPageEditor)
